import * as types from "./types";

const initialState = {
  jobs: [],
  choices: {},
  otpInfo: {},
  jobInfo: {},
};

const jobsReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.SET_JOBS:
      return {
        ...state,
        jobs: action.payload,
      };
    case types.SET_CHOICES:
      return {
        ...state,
        choices: action.payload,
      };
    case types.SET_OTP_INFO:
      return {
        ...state,
        otpInfo: action.payload,
      };
    case types.SET_JOB_INFO:
      return {
        ...state,
        jobInfo: action.payload,
      };
    default:
      return state;
  }
};

export default jobsReducer;
